<script>
  import Icon from '../icons/icon.vue';
  export default {
    components: { Icon },
  };
</script>

<template>
  <button
      @click="$emit('close')"
      class="
        layout/padding:right:page:0.5
        layout/absolute
        layout/right:0%
        layout/top:0%
        link/cursor
      ">
      <Icon
        icon-name="icon__x--24--stroke.svg"
        class-name="
          $color/black
          $typography/size:large
          typography/icon
        "/>
    </button>
</template>